module.exports = __webpack_public_path__ + "static/media/midia_mock3.f98d877a.jpg";